import { defineMessages } from "react-intl"

export const formValidationBannerMessages = defineMessages({
	additionalErrors: {
		defaultMessage: "... and {count} additional {count, plural, one {error} other {errors}}",
		id: "error.banner.additionalErrors",
	},
	fieldsAreRequired: {
		defaultMessage: "The following {count, plural, one {field is} other {fields are}} required:",
		id: "error.banner.fieldsAreRequired",
	},
	fieldsHaveInvalidValueSet: {
		defaultMessage: "The following {count, plural, one {field has} other {fields have}} invalid value set:",
		id: "error.banner.fieldsHaveInvalidValueSet",
	},
})
